module.exports = __webpack_public_path__ + "static/media/adjuge-es.259ea79a.png";